{
  "error500": {
    "title": "500 Error del Servidor",
    "subtitle": "Algo salió mal de nuestro lado",
    "description": "Pedimos disculpas por las molestias. El servidor encontró un error interno y no pudo completar su solicitud. Nuestro equipo ha sido notificado.",
    "tryAgain": "Intentar de nuevo",
    "goHome": "Ir a Inicio",
    "errorCode": "Código de error"
  },
  "sidebar": {
    "title": "Barra Lateral",
    "mobileDescription": "Muestra la barra lateral móvil.",
    "toggle": "Alternar Barra Lateral"
  },
  "nav": {
    "employeeHub": "Portal del equipo",
    "timeOff": "Ausencias",
    "orgChart": "Organigrama",
    "onboarding": "Incorporación",
    "dashboard": "Panel",
    "counters": "Contadores",
    "users": "Usuarios",
    "activityHistory": "Actividad",
    "profile": "Perfil",
    "settings": "Ajustes",
    "collapse": "Colapsar",
    "logout": "Cerrar sesión",
    "myWork": "Espacio de trabajo",
    "pipeline": "Campañas",
    "calendar": "Calendario",
    "clients": "Clientes",
    "structure": "Estructura",
    "team": "Equipo",
    "hr": "RR. HH."
  },
  "theme": {
    "light": "Claro",
    "dark": "Oscuro",
    "system": "Sistema"
  },
  "language": {
    "en": "English",
    "es": "Español",
    "sr": "Српски"
  },
  "common": {
    "user": "Usuario",
    "cancel": "Cancelar",
    "save": "Guardar",
    "dismiss": "Cerrar"
  },
  "login": {
    "title": "Bienvenido de nuevo",
    "description": "Ingresa tus credenciales para iniciar sesión en tu cuenta",
    "identifier": {
      "username": "Nombre de usuario",
      "email": "Correo electrónico",
      "both": "Nombre de usuario o correo electrónico",
      "placeholder": "Ingresa tu {{field}}"
    },
    "password": {
      "label": "Contraseña",
      "placeholder": "Ingresa tu contraseña"
    },
    "button": "Iniciar sesión",
    "button.loading": "Iniciando sesión...",
    "error": {
      "identifierRequired": "{{field}} es obligatorio",
      "passwordLength": "La contraseña debe tener al menos 6 caracteres",
      "failed": "Error al iniciar sesión",
      "unknown": "Ocurrió un error inesperado"
    },
    "forgotPassword": "¿Olvidaste tu contraseña?",
    "descriptionEmail": "Inicia sesión con tu email de trabajo",
    "descriptionPassword": "Introduce tu contraseña para continuar",
    "emailPlaceholder": "Introduce tu email",
    "change": "Cambiar",
    "continue": "Continuar",
    "or": "o",
    "google": "Continuar con Google",
    "googleSoon": "El inicio de sesión con Google aún no está configurado. Usa tu email por ahora.",
    "noAccount": "¿No tienes una cuenta?",
    "signUp": "Regístrate"
  },
  "invitation": {
    "title": "Completa Tu Registro",
    "description": "Establece tu contraseña para activar tu cuenta",
    "username": "Nombre de usuario",
    "password": "Contraseña",
    "passwordPlaceholder": "Ingresa tu contraseña",
    "confirmPassword": "Confirmar Contraseña",
    "confirmPasswordPlaceholder": "Confirma tu contraseña",
    "button": "Establecer Contraseña y Activar",
    "button.loading": "Configurando...",
    "invalidTitle": "Invitación Inválida",
    "goToLogin": "Ir a Iniciar Sesión",
    "resetPassword": {
      "title": "Restablecer Tu Contraseña",
      "description": "Ingresa una nueva contraseña para tu cuenta",
      "button": "Restablecer Contraseña",
      "button.loading": "Restableciendo..."
    },
    "error": {
      "noToken": "No se proporcionó token de invitación",
      "invalidToken": "Token de invitación inválido o expirado",
      "passwordLength": "La contraseña debe tener al menos 8 caracteres",
      "passwordMismatch": "Las contraseñas no coinciden",
      "failed": "Error al establecer contraseña. Por favor intenta de nuevo."
    }
  },
  "profile": {
    "title": "Mi Cuenta",
    "subtitle": "Gestiona tu perfil y configuración de seguridad",
    "edit": "Editar",
    "verified": "Verificado",
    "updateSuccess": "Perfil actualizado correctamente",
    "updateError": "Error al actualizar el perfil",
    "info": {
      "title": "Información del Perfil",
      "description": "Los detalles de tu cuenta"
    },
    "field": {
      "name": "Nombre Completo",
      "username": "Nombre de Usuario",
      "email": "Correo Electrónico",
      "memberSince": "Miembro Desde"
    },
    "editModal": {
      "title": "Editar Perfil",
      "description": "Actualiza la información de tu perfil"
    },
    "security": {
      "title": "Cambiar Contraseña",
      "description": "Actualiza tu contraseña para mantener tu cuenta segura",
      "currentPassword": "Contraseña Actual",
      "newPassword": "Nueva Contraseña",
      "confirmPassword": "Confirmar Nueva Contraseña",
      "passwordMismatch": "Las contraseñas no coinciden",
      "passwordInvalid": "La contraseña no cumple los requisitos",
      "changeSuccess": "Contraseña cambiada correctamente. Las demás sesiones han sido cerradas.",
      "changeError": "Error al cambiar la contraseña",
      "changeButton": "Cambiar Contraseña"
    },
    "sessions": {
      "currentSession": "Sesión Actual",
      "current": "Actual",
      "device": "Dispositivo",
      "ip": "Dirección IP",
      "lastActive": "Última Actividad",
      "now": "Ahora",
      "unknown": "Desconocido",
      "otherSessions": "Otras Sesiones",
      "otherDescription": "Sesiones activas en otros dispositivos",
      "revokeAll": "Revocar Todas",
      "revoke": "Revocar",
      "revokeSuccess": "Sesión revocada correctamente",
      "revokeError": "Error al revocar la sesión",
      "revokeAllSuccess": "Todas las demás sesiones han sido cerradas",
      "revokeAllError": "Error al revocar las sesiones",
      "noOtherSessions": "No hay otras sesiones activas",
      "lastActiveAt": "Última actividad {{time}}",
      "neverActive": "Nunca activa",
      "confirmRevokeAll": {
        "title": "Revocar Todas las Sesiones",
        "description": "Esto cerrará sesión en todos los demás dispositivos. Permanecerás conectado en este dispositivo."
      },
      "time": {
        "daysAgo": "hace {{count}} d",
        "hoursAgo": "hace {{count}} h",
        "justNow": "justo ahora",
        "minutesAgo": "hace {{count}} min"
      },
      "unknownBrowser": "Navegador desconocido",
      "unknownDevice": "Dispositivo desconocido"
    }
  },
  "settings": {
    "title": "Ajustes",
    "subtitle": "Gestiona las preferencias de tu aplicación",
    "theme": "Tema",
    "themeDescription": "Selecciona tu tema preferido",
    "language": "Idioma",
    "languageDescription": "Selecciona tu idioma preferido"
  },
  "users": {
    "title": "Usuarios",
    "button": {
      "add": "Agregar Usuario",
      "resetPassword": "Restablecer Contraseña",
      "resendInvitation": "Reenviar Invitación",
      "deactivate": "Desactivar",
      "activate": "Activar",
      "demoteFromAdmin": "Quitar rol de Administrador",
      "promoteToAdmin": "Promover a Administrador",
      "delete": "Eliminar"
    },
    "table": {
      "username": "Nombre de usuario",
      "email": "Correo electrónico",
      "name": "Nombre",
      "role": "Rol",
      "status": "Estado",
      "lastLogin": "Último Inicio de Sesión",
      "created": "Creado",
      "actions": "Acciones",
      "noResults": "No se encontraron usuarios",
      "roles": "Roles"
    },
    "status": {
      "active": "Activo",
      "inactive": "Inactivo"
    },
    "date": {
      "never": "Nunca"
    },
    "actions": {
      "label": "Acciones",
      "copyId": "Copiar ID de usuario",
      "editUser": "Editar usuario",
      "openMenu": "Abrir menú",
      "viewDetails": "Ver detalles"
    },
    "filter": {
      "allRoles": "Todos los Roles",
      "allStatus": "Todos los Estados"
    },
    "search": {
      "placeholder": "Buscar por nombre de usuario..."
    },
    "error": {
      "create": "Error al crear usuario",
      "delete": "Error al eliminar usuario",
      "resetPassword": "Error al restablecer contraseña",
      "resendInvitation": "Error al reenviar la invitación",
      "activate": "Error al activar usuario",
      "demote": "Error al quitar el rol al usuario",
      "promote": "Error al promover al usuario",
      "deactivate": "Error al desactivar usuario"
    },
    "role": {
      "USER": "Usuario",
      "ADMIN": "Administrador",
      "SUPERADMIN": "Super Administrador"
    },
    "modal": {
      "add": {
        "title": "Agregar Nuevo Usuario",
        "description": "Crea una nueva cuenta de usuario. Se generará un enlace de invitación.",
        "name": "Nombre",
        "namePlaceholder": "Ingresa el nombre completo...",
        "email": "Correo electrónico",
        "emailPlaceholder": "Ingresa el correo...",
        "emailOptional": "Correo electrónico (opcional)",
        "identifierHint": "Introduce un nombre de usuario, un correo o ambos — el usuario inicia sesión con lo que establezcas.",
        "username": "Nombre de usuario",
        "usernamePlaceholder": "Ingresa nombre de usuario...",
        "role": "Rol",
        "password": "Contraseña (opcional)",
        "passwordPlaceholder": "Deja vacío para enviar enlace de invitación",
        "passwordHint": "Si se deja vacío, se generará un enlace de invitación para que el usuario establezca su propia contraseña.",
        "button": "Crear Usuario",
        "rolePlaceholder": "Selecciona un rol"
      },
      "invitation": {
        "copied": "Enlace copiado",
        "copyFailed": "No se pudo copiar el enlace. Cópialo manualmente.",
        "title": "Enlace de Invitación",
        "message": "Comparte este enlace con el usuario para completar su registro.",
        "emailSent": "La invitación fue enviada por correo a {{email}}.",
        "emailFailed": "No se pudo enviar la invitación por correo a {{email}}. Comparte el enlace de abajo manualmente.",
        "button": {
          "copy": "Copiar Enlace",
          "done": "Hecho"
        }
      },
      "deactivate": {
        "title": "Desactivar Usuario",
        "message": "¿Estás seguro de que deseas desactivar a {{username}}?",
        "button": "Desactivar"
      },
      "selfReset": {
        "title": "Restablecer Tu Contraseña",
        "message": "Estás a punto de restablecer tu propia contraseña. Serás desconectado y necesitarás usar el enlace de invitación para volver a iniciar sesión.",
        "button": "Restablecer Contraseña"
      },
      "button": {
        "cancel": "Cancelar"
      },
      "delete": {
        "title": "Eliminar Usuario",
        "message": "Esto elimina a {{username}} para siempre y no se puede deshacer. Se cierran todas sus sesiones, no podrá volver a iniciar sesión, y su nombre de usuario y su correo quedan libres para otra persona. Para solo quitarle el acceso, desactívalo.",
        "confirm": "Escribe {{username}} para confirmar",
        "button": "Eliminar Usuario"
      }
    },
    "card": {
      "total": "en total"
    },
    "pagination": {
      "of": "de",
      "page": "Página",
      "rowsPerPage": "Filas por página"
    }
  },
  "counters": {
    "title": "Contadores",
    "description": "Gestiona tus contadores",
    "newCounter": "Nuevo Contador",
    "empty": "Aún no hay contadores. ¡Crea uno para comenzar!",
    "lastUpdated": "Última actualización:",
    "modal": {
      "title": "Crear Nuevo Contador",
      "description": "Ingresa un nombre para tu nuevo contador.",
      "nameLabel": "Nombre del Contador",
      "namePlaceholder": "Ingresa el nombre del contador...",
      "cancel": "Cancelar",
      "create": "Crear"
    },
    "clearAll": "Borrar Todo",
    "clearAllModal": {
      "cancel": "Cancelar",
      "confirm": "Eliminar Todo",
      "description": "¿Seguro que quieres eliminar los {{count}} contadores? Esta acción no se puede deshacer.",
      "title": "Borrar Todos los Contadores"
    },
    "error": {
      "create": "Error al crear el contador",
      "decrement": "Error al decrementar el contador",
      "delete": "Error al eliminar el contador",
      "deleteAll": "Error al eliminar todos los contadores",
      "increment": "Error al incrementar el contador",
      "reset": "Error al reiniciar el contador"
    },
    "loadError": "No se pudieron cargar los contadores.",
    "noResults": "Ningún contador coincide con tu búsqueda.",
    "search": "Buscar contadores...",
    "toast": {
      "incremented": "Contador incrementado"
    },
    "total": "en total"
  },
  "activity": {
    "table": {
      "timestamp": "Marca de Tiempo",
      "action": "Acción",
      "entityType": "Tipo de Entidad",
      "user": "Usuario",
      "ip": "Dirección IP",
      "status": "Estado",
      "noResults": "No se encontraron registros de actividad"
    },
    "status": {
      "success": "Éxito",
      "failed": "Fallido"
    },
    "filter": {
      "clear": "Limpiar",
      "allActions": "Todas las Acciones",
      "allEntities": "Todos los Tipos de Entidad",
      "allStatus": "Todos los Estados"
    },
    "entityType": {
      "session": "Sesión",
      "user": "Usuario",
      "counter": "Contador"
    },
    "action": {
      "LOGIN": "Inicio de Sesión",
      "LOGIN_FAILED": "Inicio Fallido",
      "LOGOUT": "Cierre de Sesión",
      "LOGOUT_ALL": "Cerrar Todas",
      "TOKEN_REFRESH": "Renovar Token",
      "CREATE": "Crear",
      "UPDATE": "Actualizar",
      "DELETE": "Eliminar",
      "PASSWORD_SET": "Contraseña Establecida",
      "PASSWORD_CHANGE": "Cambio de Contraseña",
      "PASSWORD_RESET": "Restablecer Contraseña",
      "REGISTER": "Registro",
      "EMAIL_VERIFY": "Verificar Email",
      "RESEND_VERIFICATION": "Reenviar Verificación"
    },
    "search": {
      "placeholder": "Buscar por nombre de usuario, IP, entidad..."
    },
    "button": {
      "details": "Detalles"
    },
    "modal": {
      "title": "Detalles de Actividad"
    },
    "details": {
      "error": "Error",
      "previousState": "Estado Anterior",
      "newState": "Nuevo Estado",
      "metadata": "Metadatos",
      "userAgent": "Agente de Usuario"
    },
    "pagination": {
      "of": "de",
      "page": "Página",
      "rowsPerPage": "Filas por página"
    }
  },
  "activityHistory": {
    "title": "Historial de Actividad",
    "description": "Ver registros de auditoría del sistema y actividad del usuario",
    "card": {
      "total": "registros"
    }
  },
  "toast": {
    "sessionExpired": "Sesión expirada. Por favor inicia sesión de nuevo.",
    "deviceMismatch": "Esta sesión pertenece a otro dispositivo. Por favor inicia sesión de nuevo.",
    "rateLimited": "Demasiadas solicitudes. Por favor intenta de nuevo más tarde.",
    "reconnecting": "Reconectando…",
    "unreachable": "No pudimos conectar con el servidor — puede estar reiniciándose. No se guardó nada; inténtalo de nuevo en un momento."
  },
  "backend": {
    "accountLocked": "Demasiados intentos fallidos. Inténtalo de nuevo en {{seconds}} segundos",
    "accountLockedTitle": "Cuenta bloqueada temporalmente",
    "badRequest": "La solicitud no es válida",
    "cannotAssignCustomerRole": "El rol de Cliente no se puede asignar a usuarios gestionados por administradores",
    "cannotDeactivateOwnAccount": "No puedes desactivar tu propia cuenta",
    "cannotDeleteOwnAccount": "No puedes eliminar tu propia cuenta",
    "cannotDeleteSuperAdmin": "Los usuarios Super Administradores no se pueden eliminar",
    "cannotModifyOwnRoles": "No puedes modificar tus propios roles",
    "cannotModifyOwnSuperAdmin": "No puedes modificar tu propio estado de Super Administrador",
    "cannotResendSuperAdminInvitation": "No se pueden reenviar invitaciones a usuarios Super Administradores",
    "cannotResetSuperAdminPassword": "La contraseña de un Super Administrador no se puede restablecer aquí",
    "cannotUpdateSuperAdmin": "Los usuarios Super Administradores no se pueden modificar",
    "conflict": "Esto ya existe",
    "counterNotFound": "Contador no encontrado",
    "currentPasswordIncorrect": "La contraseña actual es incorrecta",
    "emailAlreadyVerified": "Este correo electrónico ya está verificado. Puedes iniciar sesión.",
    "emailExists": "Este correo electrónico ya está registrado",
    "emailNotVerified": "Verifica tu correo electrónico antes de iniciar sesión",
    "emailRequired": "El correo electrónico es obligatorio",
    "fetchActivityFailed": "No se pudo cargar la actividad",
    "fetchProfileFailed": "No se pudo cargar tu perfil",
    "fetchSessionsFailed": "No se pudieron cargar tus sesiones",
    "fetchUsersFailed": "No se pudieron cargar los usuarios",
    "forbidden": "No tienes permiso para hacer eso",
    "identifierInUse": "Ese nombre de usuario o correo electrónico ya está en uso",
    "identifierRequired": "El nombre de usuario o correo electrónico es obligatorio",
    "invalidCredentials": "Nombre de usuario o contraseña incorrectos",
    "invalidEmail": "Formato de correo electrónico no válido",
    "invalidInvitationToken": "Enlace de invitación inválido o expirado",
    "invalidResetToken": "Este enlace para restablecer la contraseña no es válido o ha expirado",
    "invalidVerificationToken": "Este enlace de verificación no es válido o ha expirado",
    "logoutAllFailed": "No se pudieron cerrar las demás sesiones",
    "logoutFailed": "Error al cerrar sesión",
    "newPasswordSameAsCurrent": "La nueva contraseña debe ser diferente de la actual",
    "noPlatformAccess": "Tu cuenta no tiene acceso a esta aplicación",
    "notFound": "No encontrado",
    "onlySuperAdminsCreateSuperAdmins": "Solo los Super Administradores pueden crear usuarios Super Administradores",
    "onlySuperAdminsManageSuperAdmins": "Solo los Super Administradores pueden gestionar el estado de Super Administrador",
    "passwordAlreadySet": "Este usuario ya estableció una contraseña. Usa el restablecimiento de contraseña.",
    "passwordComplexity": "La contraseña no cumple los requisitos",
    "passwordMinLength": "La contraseña debe tener al menos {{count}} caracteres",
    "passwordNotSet": "Esta cuenta no tiene una contraseña establecida",
    "passwordSetupRequired": "Debes establecer tu contraseña antes de iniciar sesión",
    "profileNotFound": "Perfil no encontrado",
    "registrationFailed": "Error en el registro",
    "registrationUnavailable": "El registro no está disponible",
    "resetPasswordFailed": "Error al restablecer la contraseña",
    "revokeSessionFailed": "No se pudo revocar la sesión",
    "securityCheckFailed": "Falló la comprobación de seguridad. Recarga la página e inténtalo de nuevo.",
    "serverError": "Algo salió mal de nuestro lado. Inténtalo de nuevo.",
    "sessionNotFound": "Sesión no encontrada",
    "tooManyLoginAttempts": "Demasiados intentos de inicio de sesión. Inténtalo de nuevo en {{seconds}} segundos",
    "updateUserFailed": "Error al actualizar el usuario",
    "userNotFound": "Usuario no encontrado",
    "usernameDerivedFromEmail": "El nombre de usuario se deriva del correo electrónico cuando el inicio de sesión es por correo",
    "usernameExists": "El nombre de usuario ya existe",
    "usernameRequired": "El nombre de usuario es obligatorio",
    "verificationFailed": "Verificación fallida",
    "verificationUnavailable": "La verificación de correo electrónico no está disponible",
    "verifyInvitationFailed": "No se pudo verificar la invitación",
    "accountDeactivated": "La cuenta está desactivada",
    "accountLockedFor": "Cuenta bloqueada durante {{seconds}} segundos",
    "invalidPassword": "Contraseña incorrecta",
    "invalidPasswordLocked": "Contraseña incorrecta – cuenta bloqueada durante {{seconds}} segundos",
    "passwordPolicyDefault": "La contraseña debe contener mayúsculas, minúsculas, un número y un carácter especial",
    "platformAccessDenied": "Acceso denegado para esta plataforma ({{platform}})",
    "sendVerificationFailed": "No se pudo enviar el correo de verificación"
  },
  "dataTable": {
    "clearFilters": "Limpiar filtros",
    "columns": "Columnas",
    "noResults": "Sin resultados.",
    "pagination": {
      "next": "Siguiente",
      "pageOf": "Página {{page}} de {{pageCount}}",
      "perPage": "{{count}} / página",
      "previous": "Anterior",
      "showing": "Mostrando {{from}} a {{to}} de {{total}} resultados"
    },
    "rowsSelected": "{{selected}} de {{total}} fila(s) seleccionada(s).",
    "searchPlaceholder": "Buscar...",
    "column": {
      "actions": "Acciones",
      "createdAt": "Creado",
      "isActive": "Estado",
      "lastLoginAt": "Último Acceso",
      "name": "Nombre",
      "roles": "Roles",
      "username": "Nombre de usuario"
    }
  },
  "forgotPassword": {
    "backToLogin": "Volver a iniciar sesión",
    "description": "Ingresa tu correo electrónico y te enviaremos un enlace para restablecerla.",
    "email": "Correo electrónico",
    "emailPlaceholder": "Ingresa tu correo electrónico",
    "sent": {
      "description": "Si existe una cuenta con este correo electrónico, recibirás un enlace para restablecer la contraseña.",
      "title": "Revisa tu correo electrónico"
    },
    "submit": "Enviar Enlace",
    "title": "Olvidé mi Contraseña"
  },
  "password": {
    "error": {
      "complexity": "La contraseña no cumple los requisitos",
      "minLength": "La contraseña debe tener al menos {{count}} caracteres"
    },
    "requirement": {
      "complexity": "Cumple los requisitos de complejidad",
      "minLength": "Al menos {{count}} caracteres"
    },
    "show": "Mostrar contraseña",
    "hide": "Ocultar contraseña"
  },
  "register": {
    "button": "Crear cuenta",
    "button.loading": "Creando cuenta...",
    "confirmPassword": {
      "label": "Confirmar Contraseña",
      "placeholder": "Confirma tu contraseña"
    },
    "description": "Ingresa tus datos para crear tu cuenta",
    "email": {
      "label": "Correo electrónico",
      "placeholder": "Ingresa tu correo electrónico"
    },
    "error": {
      "failed": "Error en el registro. Inténtalo de nuevo.",
      "invalidEmail": "Ingresa un correo electrónico válido",
      "nameRequired": "El nombre es obligatorio",
      "passwordLength": "La contraseña debe tener al menos 8 caracteres",
      "passwordMismatch": "Las contraseñas no coinciden"
    },
    "hasAccount": "¿Ya tienes una cuenta?",
    "name": {
      "label": "Nombre",
      "placeholder": "Ingresa tu nombre"
    },
    "password": {
      "label": "Contraseña",
      "placeholder": "Ingresa tu contraseña"
    },
    "signIn": "Iniciar sesión",
    "success": "¡Registro exitoso! Revisa tu correo electrónico para verificar tu cuenta.",
    "title": "Crea una cuenta"
  },
  "resetPassword": {
    "confirmPassword": "Confirmar Contraseña",
    "description": "Ingresa tu nueva contraseña a continuación.",
    "error": "Error al restablecer la contraseña",
    "goToLogin": "Ir a Iniciar Sesión",
    "invalid": {
      "description": "Este enlace para restablecer la contraseña ha expirado o no es válido. Solicita uno nuevo.",
      "title": "Enlace Inválido o Expirado"
    },
    "newPassword": "Nueva Contraseña",
    "passwordInvalid": "La contraseña no cumple los requisitos",
    "passwordMismatch": "Las contraseñas no coinciden",
    "requestNew": "Solicitar Nuevo Enlace",
    "submit": "Restablecer Contraseña",
    "success": "Contraseña restablecida correctamente",
    "success.description": "Serás redirigido al inicio de sesión en breve.",
    "success.title": "Contraseña Restablecida",
    "title": "Restablecer Contraseña"
  },
  "verifyEmail": {
    "error": {
      "invalidToken": "Este enlace de verificación no es válido o ha expirado.",
      "noToken": "No se proporcionó un token de verificación",
      "title": "Verificación Fallida"
    },
    "goToLogin": "Ir a Iniciar Sesión",
    "needAccount": "¿No tienes una cuenta?",
    "resend": {
      "button": "Reenviar Correo de Verificación",
      "cancel": "Cancelar",
      "email": {
        "label": "Correo Electrónico",
        "placeholder": "Ingresa tu correo electrónico"
      },
      "emailRequired": "Ingresa tu correo electrónico",
      "sending": "Enviando...",
      "submit": "Enviar",
      "success": "Si tu correo electrónico está registrado, recibirás un correo de verificación."
    },
    "signUp": "Regístrate",
    "success": {
      "description": "Tu correo electrónico ha sido verificado correctamente. Ya puedes iniciar sesión en tu cuenta.",
      "redirect": "Redirigiendo al inicio de sesión...",
      "title": "¡Correo Verificado!"
    }
  },
  "unsavedChanges": {
    "title": "¿Salir sin guardar?",
    "body": "Se perderán tus cambios.",
    "stay": "Quedarme",
    "leave": "Salir"
  },
  "richText": {
    "bold": "Negrita",
    "italic": "Cursiva",
    "underline": "Subrayado",
    "strike": "Tachado",
    "heading": "Título",
    "paragraph": "Párrafo",
    "bullets": "Lista con viñetas",
    "numbers": "Lista numerada",
    "quote": "Cita"
  },
  "oktober": {
    "search": {
      "handbook": "Portal del equipo",
      "title": "Buscar cualquier cosa",
      "placeholder": "Busca tareas, clientes, personas y páginas…",
      "pages": "Páginas",
      "clients": "Clientes",
      "myClients": "Mis clientes",
      "tasks": "Tareas",
      "people": "Personas",
      "empty": "Nada coincide con “{{query}}”",
      "move": "para moverte",
      "open": "para abrir",
      "close": "para cerrar"
    },
    "sidebar": {
      "peopleOut": "{{count}} · {{out}} fuera",
      "daysLeft": "quedan {{count}} d",
      "findAnything": "Buscar cualquier cosa",
      "company": "Empresa",
      "system": "Sistema",
      "pod": "Pod {{name}}",
      "noPod": "Sin pod",
      "noTeam": "Sin equipo",
      "otherTeams": "Otros",
      "collapse": "Contraer menú",
      "expand": "Expandir menú",
      "home": "Inicio de October OS",
      "searchShortcut": "Buscar (Ctrl K)",
      "search": "Buscar",
      "findClient": "Buscar un cliente",
      "results": "Resultados",
      "clients": "Clientes",
      "mine": "Míos",
      "all": "Todos",
      "noMatch": "Ningún cliente coincide con “{{query}}”",
      "health": "Salud {{value}}/5"
    },
    "userMenu": {
      "language": "Idioma"
    },
    "viewingAs": {
      "label": "Viendo como",
      "hint": "Tu usuario aún no está vinculado a nadie del equipo, así que ves el trabajo de otra persona."
    },
    "splash": {
      "tagline": "Sistemas de marca para el plugin de Figma.",
      "hint": "v0.4 — versión local · haz clic para continuar"
    },
    "auth": {
      "copyright": "© {{year}} Oktober. Todos los derechos reservados."
    },
    "loading": "Cargando…",
    "notAvailable": "No disponible hasta conectar el backend.",
    "actionFailed": "Algo salió mal.",
    "errors": {
      "teamMissing": "Ese equipo ya no existe.",
      "podMissing": "Ese pod ya no existe.",
      "taskNotFound": "Tarea no encontrada.",
      "titleRequired": "El título es obligatorio.",
      "commentEmpty": "Escribe un comentario primero.",
      "employeeNotFound": "Persona no encontrada.",
      "emailTaken": "Alguien ya usa este email.",
      "selfManager": "Una persona no puede ser su propio responsable.",
      "nameEmailRequired": "El nombre y el email son obligatorios.",
      "clientNotFound": "Cliente no encontrado.",
      "nameRequired": "El nombre del cliente es obligatorio.",
      "leaveDates": "La fecha de fin es anterior a la de inicio.",
      "leaveNotFound": "Solicitud de ausencia no encontrada.",
      "templateNotFound": "Plantilla no encontrada.",
      "checklistItemNotFound": "Elemento de la lista no encontrado."
    }
  },
  "vocab": {
    "stage": { "BACKLOG": "Pendiente", "BRIEFING": "Briefing", "COPYWRITING": "Redacción", "DESIGN": "Diseño", "INTERNAL_REVIEW": "Revisión interna", "CLIENT_REVIEW": "Revisión del cliente", "IMPLEMENTATION": "Implementación", "QA_SCHEDULE": "QA y programación", "SCHEDULED": "Programado", "SENT": "Enviado" },
    "assetType": { "EMAIL_CAMPAIGN": "Campaña de email", "EMAIL_FLOW": "Flujo de email", "SMS_CAMPAIGN": "Campaña SMS", "ACCOUNT_MANAGEMENT": "Gestión de cuenta", "LIST_GROWTH": "Crecimiento de lista", "AD_CREATIVE": "Creatividad publicitaria", "DESIGN_ONLY": "Solo diseño", "AB_TEST": "Test A/B", "OTHER": "Otro" },
    "assetTypeShort": { "EMAIL_CAMPAIGN": "Campaña", "EMAIL_FLOW": "Flujo", "SMS_CAMPAIGN": "SMS", "ACCOUNT_MANAGEMENT": "AM", "LIST_GROWTH": "Lista", "AD_CREATIVE": "Anuncio", "DESIGN_ONLY": "Solo diseño", "AB_TEST": "A/B", "OTHER": "Otro" },
    "pillar": { "PRODUCT": "Producto", "CONTENT": "Contenido", "LOYALTY": "Fidelización", "PROMOTION": "Promoción", "DATA": "Datos", "WINBACK": "Recuperación" },
    "priority": { "URGENT": "Urgente", "HIGH": "Alta", "NORMAL": "Normal", "LOW": "Baja" },
    "taskRole": { "accountManager": "Gestor de cuenta", "copywriter": "Redactor", "designer": "Diseñador", "implementor": "Implementador" },
    "taskRoleShort": { "accountManager": "AM", "copywriter": "Texto", "designer": "Diseño", "implementor": "Impl" },
    "employeeRole": { "LEADERSHIP": "Dirección", "TEAM_LEAD": "Líder de equipo", "RETENTION_MANAGER": "Gestor de retención", "DESIGNER": "Diseñador", "KLAVIYO_TECH": "Técnico de Klaviyo", "OPS": "Operaciones", "OTHER": "Otro" },
    "employeeStatus": { "ONBOARDING": "Incorporación", "ACTIVE": "Activo", "OFFBOARDED": "Dado de baja" },
    "clientStatus": { "ONBOARDING": "Incorporación", "ACTIVE": "Activo", "OFFBOARDING": "En baja", "INACTIVE": "Inactivo" },
    "leaveType": { "VACATION": "Vacaciones", "SICK": "Baja por enfermedad", "OTHER": "Otro" },
    "leaveStatus": { "PENDING": "Pendiente", "APPROVED": "Aprobado", "REJECTED": "Rechazado" },
    "onboardingTarget": { "EMPLOYEE": "Empleado", "CLIENT": "Cliente" },
    "assetKind": { "LOGO": "Logotipo", "FONT": "Fuente", "IMAGE": "Imagen" }
  },
  "pipeline": {
    "eyebrow": "Pipeline de campañas",
    "title": "Pipeline",
    "viewBoard": "Tablero",
    "viewList": "Lista",
    "viewCalendar": "Calendario",
    "newTaskPlaceholder": "Título de la nueva tarea…",
    "clientPlaceholder": "Cliente…",
    "add": "Añadir",
    "searchPlaceholder": "Buscar tareas o clientes",
    "myWork": "Mi trabajo",
    "mineTitle": "Tareas donde tienes algún rol",
    "mineUnlinked": "Tu inicio de sesión aún no está vinculado a un miembro del equipo",
    "allTeams": "Todos los equipos",
    "allPods": "Todos los pods",
    "allClients": "Todos los clientes",
    "anyone": "Cualquiera",
    "allTypes": "Todos los tipos",
    "clear": "Limpiar",
    "loading": "Cargando…",
    "taskCount_one": "{{count}} tarea",
    "taskCount_other": "{{count}} tareas",
    "emailsCount_one": "{{count}} correo",
    "emailsCount_other": "{{count}} correos",
    "totalEmailsTitle": "Total de correos en esta columna",
    "showAll": "Mostrar los {{count}}",
    "blocked": "Bloqueada",
    "waitingOnClient": "Esperando al cliente",
    "sendDate": "Fecha de envío",
    "noSendDate": "Sin fecha de envío",
    "colSend": "Envío",
    "colClient": "Cliente",
    "colTask": "Tarea",
    "colType": "Tipo",
    "colStage": "Fase",
    "colPeople": "Personas",
    "workTabs": "Mis tareas",
    "tabNow": "Ahora",
    "tabUpcoming": "Próximas",
    "tabFinished": "Terminadas",
    "colName": "Nombre",
    "colMyDeadline": "Mi plazo",
    "colRoleDeadline": "Plazo: {{role}}",
    "viewLabel": "Vista",
    "colStageDeadline": "Plazo de la fase",
    "comments": "Comentarios",
    "noMatch": "Ninguna tarea coincide con estos filtros."
  },
  "calendar": {
    "eyebrow": "Calendario de envíos",
    "title": "Calendario",
    "previousMonth": "Mes anterior",
    "nextMonth": "Mes siguiente",
    "today": "Hoy",
    "internal": "Interno",
    "unscheduled_one": "{{count}} tarea sin fecha de envío (ver Lista)",
    "unscheduled_other": "{{count}} tareas sin fecha de envío (ver Lista)",
    "more": "+{{count}} más",
    "less": "Mostrar menos"
  },
  "myWork": {
    "eyebrow": "Tus tareas",
    "title": "Espacio de trabajo",
    "noPerson": "Aún no hay datos del equipo para mostrar.",
    "morning": "Buenos días, {{name}}",
    "afternoon": "Buenas tardes, {{name}}",
    "evening": "Buenas noches, {{name}}",
    "onDesk": "En tu mesa ahora: {{n}}"
  },
  "task": {
    "viewers": {
      "onlyYou": "Solo estás tú",
      "withYou": "Tú y {{names}} están aquí"
    },
    "stageView": {
      "copy": {
        "subject": "Asunto de 50 caracteres o menos",
        "preview": "Texto de vista previa escrito",
        "cta": "Un CTA claro",
        "proofread": "Revisado: ortografía, tono, voz de marca",
        "tags": "Etiquetas de personalización revisadas",
        "doc": "El copy final está en el documento maestro",
        "title": "Escribe el copy",
        "import": "Empezar desde el documento maestro",
        "subjectLabel": "Asunto",
        "previewLabel": "Texto de vista previa",
        "senderLabel": "Nombre del remitente",
        "sectionName": "Nombre de la sección",
        "up": "Subir",
        "down": "Bajar",
        "remove": "Quitar sección",
        "sectionPh": "H1: …\nCuerpo: …\nCTA: …",
        "addSection": "Añadir una sección",
        "masterDoc": "Documento maestro"
      },
      "briefing": {
        "messageLabel": "Mensaje clave y oferta",
        "openClient": "Abrir cliente y brand kit",
        "objective": "Objetivo escrito",
        "audience": "Audiencia definida",
        "message": "Mensaje clave y oferta",
        "doc": "Documento de copy creado y enlazado",
        "shared": "Brief repasado con el copywriter",
        "title": "Escribe el brief",
        "hint": "Todo lo que el copywriter necesita para empezar sin preguntar.",
        "audiencePh": "Segmentos a incluir y excluir",
        "messagePh": "Lo único que el lector debe recordar, y la oferta si la hay",
        "docTitle": "Documento de copy",
        "docHint": "Enlaza el título del email en el documento maestro para que todos lleguen directo.",
        "noNotes": "Aún no hay notas del cliente."
      },
      "notSet": "Sin completar",
      "design": {
        "copyTitle": "Copy para diseñar",
        "noCopy": "Aún no hay copy: aparecerá aquí cuando el copywriter lo escriba.",
        "figma": "Frame de Figma enlazado",
        "copy": "Usa la última versión del copy",
        "brand": "Colores, fuentes y componentes de marca",
        "mobile": "Revisado en ancho móvil",
        "images": "Imágenes exportadas y comprimidas",
        "notes": "Enlaces y textos alt anotados para Klaviyo",
        "brandTitle": "Marca",
        "copyTab": "Copy",
        "designTab": "Diseño"
      },
      "backlog": {
        "client": "Cliente elegido",
        "send": "Fecha de envío definida",
        "am": "Account manager asignado",
        "copywriter": "Copywriter asignado",
        "designer": "Diseñador asignado",
        "implementor": "Técnico de Klaviyo asignado",
        "deadlines": "Plazos internos definidos",
        "deadlinesHint": "Copy, diseño y Klaviyo",
        "title": "Planifica este email",
        "missing": "Faltan {{n}} cosas antes del brief. Complétalas en Detalles y en las personas de arriba.",
        "ready": "Todo listo: puede pasar al brief.",
        "objectivePh": "¿Qué debe lograr este email?"
      },
      "review": {
        "feedbackPh": "¿Qué hay que cambiar? Se publica como comentario.",
        "backTo": "Volver a {{stage}}",
        "brief": "Cumple el brief",
        "inbox": "El asunto y la vista previa están bien",
        "typos": "Sin erratas, el tono encaja con la marca",
        "links": "Los CTA y enlaces llevan a donde deben",
        "design": "El diseño sigue el copy y la marca",
        "mobile": "Funciona en móvil",
        "decision": "Decisión",
        "approve": "Aprobar: enviar a {{stage}}",
        "changes": "O devuélvelo con notas"
      },
      "client": {
        "msgHello": "¡Hola! El próximo email está listo para tu revisión:",
        "msgDesign": "Diseño",
        "msgCopy": "Copy",
        "msgThanks": "Avísanos si quieres algún cambio.",
        "title": "Con el cliente",
        "hint": "Envía al cliente el diseño y el copy, y registra aquí su respuesta.",
        "waiting": "Días esperando al cliente: {{n}}",
        "copyMessage": "Copiar mensaje para el cliente",
        "answer": "Respuesta del cliente",
        "feedback": "Comentarios del cliente",
        "approved": "El cliente aprobó: a {{stage}}",
        "changes": "Cambios solicitados"
      },
      "checklist": "Checklist",
      "autoCheck": "Se marca sola cuando esto se completa",
      "copyText": "Copiar",
      "copied": "Copiado",
      "build": {
        "sheet": "Hoja de montaje",
        "sheetHint": "Todo lo que se pega en Klaviyo, sacado del copy y los detalles.",
        "links": "Enlaces del copy",
        "klaviyo": "Campaña de Klaviyo",
        "openKlaviyo": "Abrir",
        "klaviyoUrl": "Enlace de la campaña",
        "template": "Plantilla montada desde el frame de Figma",
        "inbox": "Asunto, vista previa y remitente definidos",
        "segments": "Segmentos y exclusiones definidos",
        "utm": "Enlaces y UTM revisados",
        "alt": "Texto alt en cada imagen",
        "test": "Email de prueba enviado al equipo",
        "campaign": "Campaña enlazada aquí"
      },
      "qa": {
        "inbox": "La prueba llega a la bandeja, no a spam",
        "desktop": "Se ve bien en escritorio",
        "mobile": "Se ve bien en móvil y en modo oscuro",
        "links": "Cada enlace abre la página correcta",
        "tags": "La personalización se muestra, con valores por defecto",
        "footer": "Baja y pie presentes",
        "time": "Hora de envío y zona horaria confirmadas",
        "scheduled": "Programado en Klaviyo",
        "schedule": "Programación",
        "sendsAt": "Se envía {{date}}",
        "noDate": "Aún no hay fecha de envío: defínela en Detalles.",
        "markScheduled": "Marcar como {{stage}}"
      },
      "scheduled": {
        "due": "La hora de envío ya pasó",
        "inDays": "Se envía en {{n}} días",
        "inHours": "Se envía en {{n}} h"
      },
      "sent": {
        "title": "Resultados",
        "hint": "De Klaviyo, unos días después del envío.",
        "open": "Tasa de apertura %",
        "click": "Tasa de clics %",
        "revenue": "Ingresos",
        "learnings": "Qué mantener o cambiar la próxima vez"
      },
      "waitingClient": "Esperando al cliente",
      "for": "Para: {{role}}",
      "due": "Vence {{date}}",
      "modeLabel": "Área de trabajo",
      "focus": "Vista de la fase",
      "all": "Todo"
    },
    "back": "Volver",
    "loading": "Cargando…",
    "missing": "Esta tarea ya no existe.",
    "internal": "Interno",
    "sends": "Se envía {{date}}",
    "close": "Cerrar tarea",
    "blocked": "Bloqueada",
    "markBlocked": "Marcar como bloqueada",
    "moveTo": "Pasar a {{stage}}",
    "deleteConfirm": "¿Eliminar esta tarea?",
    "delete": "Eliminar tarea",
    "openInClickup": "Abrir en ClickUp",
    "layout": {
      "page": "Página",
      "modal": "Ventana",
      "drawer": "Lateral",
      "openAs": "Abrir tareas como",
      "pageTitle": "Abrir las tareas como página",
      "modalTitle": "Abrir las tareas como ventana emergente",
      "drawerTitle": "Abrir las tareas como panel lateral"
    },
    "people": {
      "nobody": "nadie",
      "unassign": "Nadie"
    },
    "details": {
      "title": "Detalles",
      "send": "Envío",
      "client": "Cliente",
      "noPillar": "Sin pilar",
      "type": "Tipo",
      "pillar": "Pilar",
      "emails": "Emails",
      "priority": "Prioridad"
    },
    "deadlines": {
      "title": "Plazos internos",
      "copy": "Copy",
      "design": "Diseño"
    },
    "brief": {
      "title": "Brief",
      "audience": "Audiencia",
      "objective": "Objetivo",
      "full": "Brief completo",
      "empty": "vacío",
      "placeholder": "Añade detalles…"
    },
    "links": {
      "title": "Enlaces",
      "copyDoc": "Documento de copy",
      "figmaFrame": "Frame de Figma",
      "paste": "Pega un enlace…",
      "open": "Abrir {{what}}",
      "edit": "Cambiar {{what}}"
    },
    "comments": {
      "title": "Comentarios",
      "placeholder": "Escribe un comentario…",
      "empty": "Aún no hay comentarios",
      "send": "Enviar comentario"
    },
    "history": {
      "title": "Historial",
      "system": "Sistema"
    },
    "timeline": {
      "label": "Etapa de la tarea",
      "current": "Etapa actual: {{stage}}",
      "moveTo": "Pasar a {{stage}}"
    },
    "activity": {
      "created": "creó la tarea",
      "imported": "importada desde ClickUp",
      "stage_changed": "movió {{from}} → {{to}}",
      "priority_changed": "cambió la prioridad a {{priority}}",
      "assigned": "asignó {{role}} a {{person}}",
      "assigned_cleared": "quitó {{role}}",
      "assignee": "responsable",
      "someone": "alguien",
      "send_changed": "fijó la fecha de envío en {{date}}",
      "send_cleared": "quitó la fecha de envío",
      "blocked": "la marcó como bloqueada",
      "unblocked": "la desbloqueó",
      "commented": "comentó",
      "edited": "editó la tarea",
      "other": "Actualizada"
    },
    "copy": {
      "title": "Copy",
      "sample": "Ejemplo",
      "refresh": "Actualizar",
      "refreshUnavailable": "Disponible cuando se conecte Google Docs",
      "openDoc": "Abrir documento",
      "reading": "Leyendo el documento de copy…",
      "noLink": "Aún no hay copy vinculado. Pega el enlace de Google Docs al encabezado del email:",
      "hintGuess": "El enlace no apunta a un encabezado, así que esta sección se buscó por fecha de envío y título. Comprueba que sea el email correcto.",
      "hintNone": "No se encontró la sección de este email: se muestra toda la pestaña. Vincula la tarea al encabezado del email para acotarla.",
      "empty": "Esta sección del documento está vacía.",
      "section": "Sección",
      "errorTitle": "No se pudo leer el copy",
      "reason": {
        "no-link": "Esta tarea aún no tiene copy vinculado.",
        "bad-link": "El enlace del copy no es un enlace de Google Docs.",
        "not-configured": "Google Docs aún no está conectado.",
        "api-disabled": "La API de Google Docs está desactivada para este proyecto.",
        "no-access": "Sin acceso a este documento de Google Docs.",
        "heading-missing": "No se encontró en el documento el encabezado del enlace.",
        "error": "Algo salió mal al leer el documento."
      }
    },
    "design": {
      "title": "Diseño",
      "previewAs": "Previsualizar como",
      "desktop": "Escritorio",
      "mobile": "Móvil",
      "rerender": "Volver a renderizar",
      "rerendering": "Renderizando…",
      "renderedAt": "Renderizado {{date}}",
      "openInFigma": "Abrir en Figma",
      "noDesign": "Aún no hay diseño. Pega el enlace al frame de Figma del email:",
      "iframeTitle": "Diseño de Figma",
      "notFigma": "El enlace del diseño no es de Figma, así que no se puede incrustar.",
      "rendering": "Renderizando el frame desde Figma…",
      "errorTitle": "No se pudo renderizar el diseño",
      "unreachable": "El servicio de vista previa no respondió. Inténtalo de nuevo en un momento.",
      "notConnected": "Vista previa disponible cuando se conecte",
      "searchMail": "Buscar en el correo",
      "inbox": "Recibidos",
      "toMe": "para mí",
      "imageAlt": "{{subject}} — diseño del email"
    }
  },
  "dashboard": {
    "hint": {
      "onDesk": "Te toca ahora",
      "dueToday": "Tu plazo vence hoy",
      "overdueMine": "Pasó tu plazo",
      "upcoming": "Aún con otros",
      "waiting": "En revisión del cliente",
      "sendingToday": "Envíos de tus clientes",
      "overdue": "Pasó la fecha de envío",
      "watch": "Salud baja, salida o sin envíos"
    },
    "personal": {
      "intro": "Esto es lo que tienes hoy en tu mesa.",
      "clear": "Tu mesa está despejada: nada te espera.",
      "noDate": "Sin fecha",
      "kpi": {
        "onDesk": "En tu mesa",
        "dueToday": "Vence hoy",
        "overdue": "Atrasadas",
        "upcoming": "Por llegar",
        "waiting": "Esperando al cliente",
        "sendingToday": "Se envían hoy"
      },
      "desk": {
        "title": "En tu mesa",
        "all": "Espacio de trabajo →",
        "empty": "Nada en tu mesa. Disfrútalo."
      },
      "upcoming": {
        "title": "Por llegar",
        "empty": "Todavía no llega nada."
      },
      "clients": {
        "title": "Mis clientes",
        "empty": "Aún no tienes clientes asignados."
      }
    },
    "there": "ahí",
    "greeting": {
      "morning": "Buenos días, {{name}}",
      "afternoon": "Buenas tardes, {{name}}",
      "evening": "Buenas noches, {{name}}"
    },
    "intro": {
      "nothingToday": "Hoy no sale nada.",
      "emails_one": "Hoy sale {{count}} email en {{sends}}",
      "emails_other": "Hoy salen {{count}} emails en {{sends}}",
      "sends_one": "{{count}} envío",
      "sends_other": "{{count}} envíos",
      "notReady": " — {{count}} sin programar todavía.",
      "allScheduled": ", todos programados.",
      "nothingOnYou": "Nada está esperándote.",
      "onYou_one": "{{count}} tarea te está esperando.",
      "onYou_other": "{{count}} tareas te están esperando."
    },
    "kpi": {
      "emailsToday": "Emails hoy",
      "emailsWeek": "Emails próximos 7 días",
      "waiting": "Esperando al cliente",
      "overdue": "Tareas vencidas",
      "watch": "Cuentas a vigilar"
    },
    "goingOut": {
      "title": "Saliendo",
      "calendar": "Calendario →",
      "today": "Hoy",
      "tomorrow": "Mañana",
      "nothingPlanned": "nada planificado",
      "notScheduled": "{{open}} de {{total}} sin programar todavía",
      "scheduled": "{{count}} programados"
    },
    "internal": "Interno",
    "moreCount": "+{{count}} más",
    "pods": {
      "title": "Pods",
      "structure": "Estructura →",
      "pod": "Pod",
      "clients": "Clientes",
      "open": "Abiertas",
      "overdue": "Vencidas",
      "waiting": "En espera"
    },
    "myWork": {
      "title": "Mi trabajo",
      "all": "Todo →",
      "noPersonBefore": "Tu inicio de sesión aún no está vinculado a un miembro del equipo: añádete en la página",
      "team": "Equipo",
      "noPersonAfter": "con el mismo email.",
      "empty": "Nada abierto. Disfrútalo.",
      "onYou": "Esperándote a ti",
      "elsewhere": "En manos de otra persona"
    },
    "watch": {
      "title": "Cuentas a vigilar",
      "healthy": "Todas las cuentas se ven sanas.",
      "offboarding": "Baja en curso",
      "health": "Salud {{value}}/5",
      "nothingSending": "Sin envíos en 14 días"
    },
    "out": {
      "title": "Ausentes hoy",
      "everyoneIn": "Todos están presentes.",
      "until": "hasta el {{date}}",
      "days_one": "{{count}} día",
      "days_other": "{{count}} días"
    },
    "onboarding": {
      "title": "Incorporación",
      "hr": "RR. HH. →"
    }
  },
  "hub": {
    "topics": "Temas",
    "resultsFor": "{{n}} resultados para “{{query}}”",
    "clear": "Borrar",
    "groupText": {
      "onboarding": "Tus primeros días: quiénes somos, las herramientas y los canales.",
      "policies": "Vacaciones, bajas por enfermedad, horas de sincronía y las reglas del Q4.",
      "money": "Facturas, bonos y referidos.",
      "work": "Cómo está organizado el equipo, Slack y nuestras reuniones.",
      "events": "Reuniones del equipo."
    },
    "title": "Portal del equipo",
    "empty": "El manual aún no se ha importado.",
    "search": "Buscar en el portal…",
    "home": "Inicio",
    "welcome": "Todo sobre trabajar en OKTOBER",
    "intro": "Vacaciones, pagos, cómo trabajamos juntos y cómo empezar, en un solo lugar.",
    "synced": "Sincronizado desde ClickUp el {{date}}",
    "openClickUp": "Abrir en ClickUp",
    "startHere": "Empieza aquí",
    "startHereName": "Empieza aquí, {{name}}",
    "glance": "De un vistazo",
    "updated": "Actualizado {{date}}",
    "readTime": "{{n}} min de lectura",
    "onThisPage": "En esta página",
    "previous": "Anterior",
    "next": "Siguiente",
    "noResults": "Nada en el portal coincide con “{{query}}”",
    "group": {
      "onboarding": "Incorporación",
      "policies": "Ausencias y políticas",
      "money": "Pagos y facturas",
      "work": "Cómo trabajamos",
      "events": "Eventos"
    }
  },
  "hr": {
    "eyebrow": "Gestión de personas",
    "title": "RR. HH.",
    "tab": {
      "hub": "Portal del equipo",
      "leave": "Ausencias",
      "org": "Organigrama",
      "onboarding": "Incorporación"
    },
    "leave": {
      "teamMember": "— miembro del equipo —",
      "from": "Desde",
      "to": "Hasta",
      "request": "Solicitar",
      "empty": "No hay solicitudes este año.",
      "days_one": "{{count}} día",
      "days_other": "{{count}} días",
      "approve": "Aprobar",
      "reject": "Rechazar",
      "balance": "Saldo de vacaciones",
      "left": "{{remaining}}/{{allowance}} restantes",
      "allowanceNote": "20 días al año por defecto — la asignación de cada persona se puede cambiar en su perfil."
    },
    "org": {
      "teams": "Equipos",
      "pods": "Pods",
      "people": "Personas",
      "clients": "Clientes",
      "teamMeta": "{{pods}} pods · {{people}} personas · {{clients}} clientes",
      "teamLead": "Team lead",
      "designLead": "Líder de diseño",
      "podLead": "Líder del pod",
      "retention": "Retención",
      "design": "Diseño",
      "others": "Otros",
      "emptyPod": "Nadie más en este pod todavía",
      "shared": "Para todo el equipo",
      "noPod": "Aún sin pod",
      "techs": "Técnicos de Klaviyo",
      "techsHint": "Equipos según las tareas que implementan",
      "floating": "Sin equipo",
      "floatingHint": "Diseñadores flotantes, dirección y operaciones",
      "empty": "Aún no hay miembros del equipo.",
      "note": "La jerarquía proviene del campo \"Responsable / mentor\" del perfil de cada persona."
    },
    "onb": {
      "templates": "Plantillas",
      "new": "Nueva",
      "namePlaceholder": "Nombre de la plantilla (p. ej. Nuevo diseñador)",
      "forEmployees": "Para miembros del equipo",
      "forClients": "Para clientes",
      "itemsPlaceholder": "Un elemento por línea:\nContrato firmado\nPortátil entregado\nCuentas creadas",
      "save": "Guardar",
      "cancel": "Cancelar",
      "edit": "Editar",
      "items_one": "{{count}} elemento",
      "items_other": "{{count}} elementos",
      "runs_one": "{{count}} ejecución",
      "runs_other": "{{count}} ejecuciones",
      "pickEmployee": "— miembro del equipo —",
      "pickClient": "— cliente —",
      "start": "Iniciar",
      "active": "Incorporaciones activas",
      "empty": "No hay incorporaciones en curso."
    }
  },
  "clients": {
    "assetUnavailable": "Archivo no disponible hasta que se conecte el almacenamiento",
    "cancel": "Cancelar",
    "create": "Crear",
    "eyebrow": "Repositorio",
    "title": "Clientes",
    "newClient": "Nuevo cliente",
    "searchPlaceholder": "Buscar clientes…  ( / )",
    "namePlaceholder": "Nombre del cliente (p. ej. Maison Hatch)",
    "empty": {
      "title": "Aún no hay clientes",
      "body": "Crea un cliente para guardar su logotipo, guías de marca, fuentes e imágenes en un solo lugar."
    },
    "noMatch": "Ningún cliente coincide con «{{query}}».",
    "count_one": "{{count}} cliente",
    "count_other": "{{count}} clientes",
    "colorsCount_one": "{{count}} color",
    "colorsCount_other": "{{count}} colores",
    "fontsCount_one": "{{count}} fuente",
    "fontsCount_other": "{{count}} fuentes",
    "imagesCount_one": "{{count}} imagen",
    "imagesCount_other": "{{count}} imágenes",
    "scaleLabel": "{{n}} de {{max}}",
    "tabs": {
      "overview": "Resumen",
      "pipeline": "Pipeline",
      "calendar": "Calendario",
      "team": "Equipo",
      "onboarding": "Incorporación",
      "brand": "Kit de marca"
    },
    "detail": {
      "allClients": "← Todos los clientes",
      "notFound": "Cliente no encontrado.",
      "podLead": "Líder del pod: {{name}}",
      "noPod": "{{team}} · sin pod",
      "noTeam": "Sin equipo asignado",
      "health": "Salud",
      "nps": "NPS",
      "clientSince": "Cliente desde {{date}}",
      "newTask": "Nueva tarea",
      "moreActions": "Más acciones",
      "rename": "Renombrar cliente",
      "renamePrompt": "Nombre del cliente",
      "openClickUp": "Abrir en ClickUp",
      "delete": "Eliminar cliente",
      "deleteConfirm": "¿Eliminar el cliente «{{name}}»? Sus tareas se conservan, pero pierden el cliente."
    },
    "overview": {
      "openTasks": "Tareas abiertas",
      "waitingOnClient": "Esperando al cliente",
      "overdue": "Vencidas",
      "emailsNext7": "Emails próximos 7 días",
      "emailsSent30": "Emails enviados, 30 días",
      "needsAttention": "Requiere atención",
      "allClear": "Todo en orden: nada bloqueado, atrasado ni en espera.",
      "goingOut": "Próximos envíos — 14 días",
      "nothingScheduled": "No hay nada programado para enviar en las próximas dos semanas.",
      "pipeline": "Pipeline",
      "people": "Personas en este cliente",
      "noOneAssigned": "Aún no hay nadie asignado.",
      "podLead": "Líder del pod",
      "podMember": "Pod",
      "assigned": "Asignado",
      "recentActivity": "Actividad reciente",
      "noActivity": "Aún no hay cambios en October OS.",
      "system": "Sistema",
      "onTask": "en",
      "reason": {
        "blocked": "Bloqueada",
        "overdue": "Vencida",
        "waiting": "Esperando al cliente",
        "atRisk": "En riesgo",
        "noDate": "Sin fecha de envío"
      },
      "noSendDate": "sin fecha de envío",
      "hasIt": "{{name}} la tiene",
      "allScheduled": "todo programado",
      "notScheduled_one": "{{count}} sin programar aún",
      "notScheduled_other": "{{count}} sin programar aún",
      "noOpenTasks": "No hay tareas abiertas.",
      "openPipeline": "Abrir el pipeline",
      "emailsPerWeek": "Emails por semana",
      "sent": "enviados",
      "planned": "planificados",
      "weekTitle_one": "Semana del {{date}}: {{count}} email",
      "weekTitle_other": "Semana del {{date}}: {{count}} emails",
      "account": "Cuenta",
      "status": "Estado",
      "pod": "Pod",
      "none": "— ninguno —",
      "health": "Salud",
      "clientSince": "Cliente desde",
      "contractEnd": "Fin del contrato",
      "scope": "Alcance",
      "notes": "Notas",
      "scopePlaceholder": "Lo que hacemos por ellos (p. ej. 12 campañas/mes + flows)",
      "notesPlaceholder": "Cualquier cosa que el equipo deba saber sobre este cliente…"
    },
    "team": {
      "podTitle": "{{team}} · Pod {{pod}}",
      "pod": "Pod",
      "structure": "Estructura",
      "noPod": "Aún sin pod: elige uno en Cuenta, en la pestaña Resumen.",
      "alsoAssigned": "También asignados",
      "nobodyOutside": "Nadie fuera del pod.",
      "remove": "Quitar",
      "assignAria": "Asignar a alguien a este cliente",
      "assignPlaceholder": "+ Asignar a alguien…",
      "workedOnRecent": "Trabajaron en tareas recientes",
      "roleOn": "{{role}} en {{n}}",
      "lead": "Líder",
      "noTasks": "Sin tareas en las últimas 8 semanas"
    }
  },
  "brandKit": {
    "notFound": "Cliente no encontrado.",
    "tabs": {
      "colors": "Colores",
      "typography": "Tipografía",
      "style": "Estilo",
      "figma": "Figma",
      "assets": "Recursos",
      "brand": "Documento de marca"
    },
    "readBy": "Lo lee el plugin Figma Email Designer.",
    "saved": "Guardado",
    "saving": "Guardando…",
    "save": "Guardar kit de marca",
    "remove": "Quitar",
    "copy": "Clic para copiar",
    "colors": {
      "add": "Añadir color",
      "addHint": "HEX con nombre y rol opcionales",
      "namePlaceholder": "Nombre (p. ej. Atardecer)",
      "addButton": "Añadir color",
      "other": "Otros",
      "empty": "Aún no hay colores: añade uno arriba. Los tokens se guardan en el próximo «Guardar cambios».",
      "token": "Token",
      "contrastWhite": "Contraste {{ratio}} sobre blanco",
      "contrastBlack": "Contraste {{ratio}} sobre negro"
    },
    "roles": {
      "primary": "Primario",
      "secondary": "Secundario",
      "accent": "Acento",
      "neutral": "Neutro",
      "semantic": "Semántico"
    },
    "typography": {
      "scale": "Escala tipográfica",
      "scaleHint": "Tamaños (px) que usa el plugin para títulos, texto y botones. El email se renderiza a 1200 px de ancho.",
      "body": "Cuerpo",
      "bodySmall": "Cuerpo pequeño",
      "button": "Botón",
      "specimens": "Muestras de fuentes",
      "specimensEmpty": "Sube .otf / .ttf / .woff / .woff2: se cargarán mediante @font-face.",
      "specimensLoaded_one": "{{count}} fuente cargada mediante @font-face",
      "specimensLoaded_other": "{{count}} fuentes cargadas mediante @font-face",
      "uploadFont": "Subir fuente",
      "dragHint": "Arrastrar y soltar está en la pestaña Recursos. Los archivos aparecen aquí como muestras.",
      "noFonts": "Aún no se han subido fuentes.",
      "pairings": "Combinaciones",
      "pairingsHint": "Combinaciones de título + cuerpo para recomendar en los emails",
      "addPairing": "Añadir combinación",
      "pairingName": "Combinación {{n}}",
      "removeFont": "Quitar fuente",
      "sampleHeading": "Aa Bb Cc",
      "pangram": "El veloz murciélago hindú comía feliz cardillo y kiwi. 0123456789",
      "heading": "Título",
      "sampleTitle": "Nueva temporada, nuevas formas.",
      "sampleBody": "Un párrafo corto en la fuente del cuerpo. Pensada para el texto de tus emails: limpia, legible en pantallas pequeñas y coherente con la voz de tu marca."
    },
    "style": {
      "radii": "Radios",
      "radiiHint": "Escala de radios de esquina. El plugin los lee al construir frames desde cero.",
      "small": "Pequeño (sm)",
      "smallHint": "campos / chips",
      "card": "Tarjeta",
      "cardHint": "tarjetas de producto",
      "section": "Sección",
      "sectionHint": "bloques grandes redondeados",
      "pill": "Píldora",
      "pillHint": "botones de píldora completa",
      "shadows": "Sombras",
      "shadowsHint": "Recetas estilo CSS: cópialas tal cual de tus tokens.",
      "elevated": "Elevada",
      "buttonSpec": "Especificación de botón",
      "buttonSpecHint": "Cómo se renderizan los CTA desde cero: relleno, fuente, transformación, radio.",
      "fontFamily": "Familia de fuente",
      "fontFamilyHint": "Déjalo vacío para usar la fuente del cuerpo",
      "fontFamilyPlaceholder": "p. ej. Apercu Pro",
      "paddingY": "Relleno Y",
      "paddingX": "Relleno X",
      "fontSize": "Tamaño de fuente",
      "fontWeight": "Grosor de fuente",
      "weight400": "Normal (400)",
      "weight500": "Medio (500)",
      "weight700": "Negrita (700)",
      "transform": "Transformación",
      "uppercase": "MAYÚSCULAS",
      "normal": "Normal",
      "letterSpacing": "Espaciado de letras (em)",
      "radius": "Radio",
      "cardRadius": "Radio de tarjeta",
      "smallRadius": "Radio pequeño",
      "cardSpec": "Especificación de tarjeta",
      "cardSpecHint": "Cómo se renderizan desde cero las tarjetas de producto / contenido.",
      "gap": "Espacio",
      "surface": "Superficie",
      "surfacePlaceholder": "#FFFFFF o nombre de token",
      "shadow": "Sombra",
      "cardRecipe": "Receta de tarjeta",
      "elevatedRecipe": "Receta elevada",
      "none": "Ninguna"
    },
    "figma": {
      "header": "Cabecera",
      "headerHint": "Logotipo + navegación. Se antepone a cada email; no se genera texto con IA para él.",
      "hero": "Hero",
      "heroHint": "Titular + subtítulo + CTA principal",
      "body": "Cuerpo",
      "bodyHint": "Párrafos, títulos secundarios, separadores, CTA dentro del cuerpo",
      "product": "Producto",
      "productHint": "Cuadrículas de tarjetas: imagen + nombre + precio + CTA",
      "footer": "Pie de página",
      "footerHint": "Enlaces, dirección, baja, iconos sociales",
      "mapping": "Mapeo de componentes de Figma",
      "mappingHint": "Cuando el plugin construye un email para este cliente, instancia estos componentes por nombre (buscados en el archivo de Figma actual). Déjalo vacío para usar el constructor de frames genérico.",
      "placeholder": "p. ej. EmailHero/Default",
      "slots": "Convención de slots",
      "slotsHint": "Dentro de tus componentes registrados, nombra las capas de texto como abajo para recibir el texto generado.",
      "layerNames": "Los nombres de capa aceptan cualquiera de",
      "or": "o"
    },
    "assets": {
      "logo": "Logotipo",
      "logoHint": "Se prefiere SVG; PNG también sirve",
      "replace": "Reemplazar",
      "dropLogo": "Suelta el logotipo aquí o haz clic para elegir",
      "fonts": "Fuentes",
      "images": "Imágenes",
      "dropFonts": "Suelta las fuentes aquí o haz clic para elegir",
      "dropImages": "Suelta las imágenes aquí o haz clic para elegir",
      "fileCount_one": "{{count}} archivo",
      "fileCount_other": "{{count}} archivos",
      "removeConfirm": "¿Quitar «{{name}}»?"
    },
    "doc": {
      "title": "Guías de marca",
      "hint": "Markdown: voz, paleta, tipografía, restricciones. Lo lee /generate."
    }
  },
  "team": {
    "details": {
      "profile": "Perfil",
      "email": "Email",
      "emailHint": "Para entrar con Google",
      "roleTeam": "Rol y equipo",
      "role": "Rol",
      "level": "Nivel",
      "noPod": "Sin pod",
      "employment": "Empleo",
      "login": "Acceso",
      "loginLinked": "Ya ha entrado",
      "loginNone": "Aún no ha entrado",
      "deleteHint": "La quita de tareas, pods y el organigrama."
    },
    "tabDetails": "Detalles",
    "profile": {
      "onDesk": "En su mesa",
      "upcoming": "Por llegar",
      "clients": "Clientes",
      "daysLeft": "Días libres restantes",
      "desk": "En su mesa",
      "allTasks": "Todas las tareas →",
      "deskEmpty": "Nada en su mesa ahora mismo.",
      "worksOn": "Trabaja en",
      "noClients": "Sin clientes ahora mismo.",
      "place": "En el equipo",
      "team": "Equipo",
      "noTeam": "Sin equipo",
      "pod": "Pod",
      "reportsTo": "Reporta a",
      "reports": "Le reportan",
      "timeOff": "Ausencias",
      "hr": "Ausencias →",
      "leftOf": "Quedan {{left}} de {{total}} días este año",
      "noLeave": "Sin ausencias previstas.",
      "pending": "Pendiente",
      "assigned": "Clientes asignados",
      "unassign": "Quitar",
      "noneAssigned": "Ninguno: su pod y sus tareas muestran dónde trabaja.",
      "assign": "Asignar un cliente…"
    },
    "eyebrow": "Personas",
    "eyebrowCount": "Personas · {{count}}",
    "title": "Equipo",
    "searchPlaceholder": "Buscar en el equipo…",
    "newEmployee": "Nueva persona",
    "fullName": "Nombre completo",
    "emailPlaceholder": "nombre@oktoberagency.com",
    "add": "Añadir",
    "cancel": "Cancelar",
    "emptyTitle": "Aún no hay personas",
    "emptyHint": "Añade a tu primer miembro del equipo: su correo lo vincula con su acceso de Google.",
    "clientCount_one": "{{count}} cliente",
    "clientCount_other": "{{count}} clientes",
    "noLogin": "aún sin acceso",
    "notFound": "Persona no encontrada.",
    "saved": "Guardado ✓",
    "saving": "Guardando…",
    "deleteConfirm": "¿Eliminar a {{name}} del equipo?",
    "tabOverview": "Resumen",
    "tabClients_one": "Clientes ({{count}})",
    "tabClients_other": "Clientes ({{count}})",
    "tabTasks": "Tareas",
    "basics": "Datos básicos",
    "emailLabel": "Correo (usado para el acceso con Google)",
    "jobTitle": "Puesto",
    "teamLabel": "Equipo",
    "phone": "Teléfono",
    "statusStructure": "Estado y estructura",
    "status": "Estado",
    "startDate": "Fecha de inicio",
    "manager": "Responsable / mentor (organigrama)",
    "managerNone": "— ninguno —",
    "directReports": "Personas a cargo:",
    "loginLabel": "Acceso:",
    "loginLinked": "vinculado ✓",
    "loginNone": "aún no ha iniciado sesión",
    "notes": "Notas",
    "notesPlaceholder": "Notas internas sobre esta persona…",
    "deleteEmployee": "Eliminar persona",
    "worksOn": "Clientes en los que trabaja {{name}}",
    "noClients": "Aún no hay clientes.",
    "open": "Abrir",
    "assigned": "Asignado ✓",
    "assign": "Asignar"
  },
  "structure": {
      "eyebrow": "Equipos · pods · clientes",
      "title": "Estructura",
      "unpodded_one": "{{count}} cliente aún no está en un pod:",
      "unpodded_other": "{{count}} clientes aún no están en un pod:",
      "ledBy": "dirigido por {{name}}",
      "pod": "Pod {{name}}",
      "clientsCount_one": "{{count}} cliente",
      "clientsCount_other": "{{count}} clientes",
      "openTasksCount_one": "{{count}} tarea abierta",
      "openTasksCount_other": "{{count}} tareas abiertas",
      "noLead": "Sin líder RM3",
      "floating": "Entre equipos / sin asignar",
      "unplaced": "Clientes sin equipo",
      "mentor": "mentor: {{name}}",
      "start": "inicio {{date}}",
      "new": "nuevo",
      "health": "salud {{value}}/5"
  },
  "picker": {
    "search": "Buscar…",
    "noMatch": "Sin resultados",
    "pickDate": "Elegir fecha",
    "prevMonth": "Mes anterior",
    "nextMonth": "Mes siguiente",
    "today": "Hoy",
    "clear": "Borrar",
    "done": "Listo",
    "hours": "Horas",
    "minutes": "Minutos"
  },
  "ai": {
    "answeringAs": "Respondiendo como {{name}}",
    "chip": {
      "findCampaigns_one": "Revisó {{count}} campaña",
      "findCampaigns_other": "Revisó {{count}} campañas",
      "findCampaignsRunning": "Revisando campañas…",
      "getCampaign": "Abrió una campaña",
      "getCampaignRunning": "Abriendo una campaña…",
      "getCampaignCopy": "Leyó el texto de una campaña",
      "getCampaignCopyRunning": "Leyendo el texto de una campaña…",
      "findClients_one": "Revisó {{count}} cliente",
      "findClients_other": "Revisó {{count}} clientes",
      "findClientsRunning": "Revisando clientes…",
      "getClient": "Abrió un cliente",
      "getClientRunning": "Abriendo un cliente…",
      "findPeople_one": "Revisó {{count}} persona",
      "findPeople_other": "Revisó {{count}} personas",
      "findPeopleRunning": "Revisando personas…",
      "getPerson": "Abrió un perfil",
      "getPersonRunning": "Abriendo un perfil…",
      "getStructure": "Revisó la estructura",
      "getStructureRunning": "Revisando la estructura…",
      "getTimeOff_one": "Revisó {{count}} solicitud de ausencia",
      "getTimeOff_other": "Revisó {{count}} solicitudes de ausencia",
      "getTimeOffRunning": "Revisando ausencias…",
      "getHandbook": "Leyó el manual",
      "getHandbookRunning": "Leyendo el manual…",
      "createCampaigns_one": "Creó {{name}}",
      "createCampaigns_other": "Creó {{count}} campañas",
      "createCampaignsRunning": "Creando campañas…",
      "updateCampaigns_one": "Actualizó {{name}}",
      "updateCampaigns_other": "Actualizó {{count}} campañas",
      "updateCampaignsRunning": "Actualizando campañas…",
      "shiftCampaignDates_one": "Movió las fechas de {{name}}",
      "shiftCampaignDates_other": "Movió las fechas de {{count}} campañas",
      "shiftCampaignDatesRunning": "Moviendo fechas de campañas…",
      "deleteCampaigns_one": "Eliminó {{name}}",
      "deleteCampaigns_other": "Eliminó {{count}} campañas",
      "deleteCampaignsRunning": "Eliminando campañas…",
      "commentOnCampaigns_one": "Comentó en {{name}}",
      "commentOnCampaigns_other": "Comentó en {{count}} campañas",
      "commentOnCampaignsRunning": "Comentando en campañas…",
      "updateClient": "Actualizó {{name}}",
      "updateClientRunning": "Actualizando un cliente…",
      "setClientTeamMember": "Cambió el equipo de un cliente",
      "setClientTeamMemberRunning": "Cambiando el equipo de un cliente…",
      "requestTimeOff": "Solicitó una ausencia",
      "requestTimeOffRunning": "Solicitando una ausencia…",
      "decideTimeOff": "Resolvió una solicitud de ausencia",
      "decideTimeOffRunning": "Resolviendo una solicitud de ausencia…",
      "updatePersonPlacement": "Cambió el lugar de una persona en la estructura",
      "updatePersonPlacementRunning": "Cambiando el lugar de una persona en la estructura…",
      "setLead": "Cambió un líder",
      "setLeadRunning": "Cambiando un líder…",
      "other": "{{tool}}: hecho",
      "otherRunning": "{{tool}}: en curso…",
      "failed": "No funcionó: {{tool}}",
      "tool": {
        "findCampaigns": "Buscar campañas",
        "getCampaign": "Abrir una campaña",
        "getCampaignCopy": "Leer el texto de una campaña",
        "findClients": "Buscar clientes",
        "getClient": "Abrir un cliente",
        "findPeople": "Buscar personas",
        "getPerson": "Abrir un perfil",
        "getStructure": "Revisar la estructura",
        "getTimeOff": "Revisar ausencias",
        "getHandbook": "Leer el manual",
        "createCampaigns": "Crear campañas",
        "updateCampaigns": "Actualizar campañas",
        "shiftCampaignDates": "Mover fechas de campañas",
        "deleteCampaigns": "Eliminar campañas",
        "commentOnCampaigns": "Comentar en campañas",
        "updateClient": "Actualizar un cliente",
        "setClientTeamMember": "Cambiar el equipo de un cliente",
        "requestTimeOff": "Solicitar una ausencia",
        "decideTimeOff": "Resolver una solicitud de ausencia",
        "updatePersonPlacement": "Cambiar el lugar de alguien en la estructura",
        "setLead": "Cambiar un líder"
      }
    },
    "ask": "Pregunta a Okto",
    "chats": "Chats",
    "newChat": "Nuevo chat",
    "openInChats": "Abrir en Chats",
    "close": "Cerrar",
    "noChats": "Aún no hay chats",
    "allChats": "Todos los chats",
    "untitled": "Chat sin título",
    "chatActions": "Acciones del chat",
    "chatTitle": "Título del chat",
    "rename": "Renombrar",
    "delete": "Eliminar",
    "group": {
      "today": "Hoy",
      "yesterday": "Ayer",
      "lastWeek": "Semana pasada",
      "older": "Anteriores"
    },
    "placeholder": "Pregúntale a Okto lo que quieras…",
    "send": "Enviar",
    "attach": "Adjuntar archivos",
    "chatFull": "Este chat no admite más archivos. Empieza un chat nuevo para ellos.",
    "file": {
      "uploading": "Subiendo…",
      "remove": "Quitar {{name}}",
      "open": "Abrir {{name}}",
      "openFailed": "No se pudo abrir este archivo.",
      "drop": "Suelta los archivos para Okto",
      "error": {
        "kind": "Okto lee archivos PDF, Word, texto, Markdown, CSV e imágenes.",
        "tooBig": "Demasiado grande: este tipo de archivo puede tener hasta {{size}}.",
        "tooLong": "Demasiado largo para Okto. Prueba con un archivo más corto o solo las páginas que necesitas.",
        "unreadable": "Okto no pudo leer este archivo. Puede estar vacío, dañado o protegido con contraseña.",
        "failed": "No se pudo subir este archivo. Inténtalo de nuevo.",
        "tooMany": "Un mensaje admite hasta {{count}} archivos."
      }
    },
    "loading": "Cargando…",
    "thinking": "Okto está pensando…",
    "steps_one": "{{count}} paso",
    "steps_other": "{{count}} pasos",
    "reset": "Los datos de ejemplo se reiniciaron desde este chat. Los cambios de arriba ya no existen.",
    "refused": "Okto no pudo ayudar con eso.",
    "error": "Algo salió mal.",
    "retry": "Reintentar",
    "busy": "Este chat está ocupado en otra ventana. Inténtalo de nuevo en un momento.",
    "stoppedAfterRounds": "Se detuvo tras {{rounds}} rondas de consultas. Envía un mensaje para continuar.",
    "cancelled": "{{tool}}: cancelado",
    "cancelledByReload": "{{tool}}: cancelado al recargar",
    "notRun": "{{tool}}: no se ejecutó",
    "empty": {
      "title": "Hola, soy Okto",
      "hint": "Pregúntame por clientes, personas, campañas y ausencias, o pídeme un cambio. Te consultaré antes de cualquier cambio grande."
    },
    "confirm": {
      "yes": "Hazlo",
      "no": "Cancelar",
      "more": "y {{count}} más",
      "delete_one": "Esto elimina {{count}} campaña para siempre.",
      "delete_other": "Esto elimina {{count}} campañas para siempre.",
      "people_one": "Esto cambia quién trabaja en {{count}} campaña.",
      "people_other": "Esto cambia quién trabaja en {{count}} campañas.",
      "clientAdd": "Esto añade a alguien al equipo de un cliente.",
      "clientRemove": "Esto quita a alguien del equipo de un cliente.",
      "clientPod": "Esto mueve al cliente a otro pod, lo que cambia todo su equipo.",
      "placement": "Esto mueve a alguien dentro de la estructura del equipo.",
      "lead": "Esto cambia quién lidera un equipo o pod.",
      "approve": "Esto aprueba una solicitud de ausencia.",
      "reject": "Esto rechaza una solicitud de ausencia.",
      "bulk_one": "Esto cambia {{count}} registro.",
      "bulk_other": "Esto cambia {{count}} registros.",
      "alreadyDone_one": "Ya se cambió {{count}}.",
      "alreadyDone_other": "Ya se cambiaron {{count}}."
    },
    "model": {
      "label": "Modelo",
      "note": {
        "opus": "Potente para todo",
        "sonnet": "Más rápido, a mitad de precio",
        "haiku": "El más rápido y barato, para consultas simples"
      }
    },
    "admin": {
      "title": "Chats de admin",
      "model": {
        "label": "Modelo para todos",
        "pick": "Modelo para todos: {{model}}",
        "changed": "Ahora todos usan {{model}}",
        "changedBy": "Cambiado por {{name}} · {{when}}",
        "neverChanged": "Predeterminado, sin cambios"
      },
      "unknownUser": "Usuario desconocido",
      "readOnly": "Solo lectura",
      "deletedAccount": "(cuenta eliminada)",
      "loadFailed": "No se pudieron cargar los chats.",
      "openFailed": "No se pudo cargar este chat.",
      "gone": "Este chat ya no existe.",
      "back": "Todos los chats",
      "search": "Buscar pregunta o cuenta",
      "deleted": "eliminado",
      "deletedByOwner": "Eliminado por su propietario",
      "slowHint": "Una llamada tardó 30 s o más",
      "total": {
        "spend": "Gasto",
        "conversations": "Conversaciones",
        "tokens": "Tokens de entrada / en caché / de salida"
      },
      "col": {
        "when": "Cuándo",
        "account": "Cuenta",
        "question": "Pregunta",
        "turns": "Turnos",
        "cost": "Coste",
        "model": "Modelo",
        "time": "Tiempo",
        "status": "Estado"
      },
      "tokens": {
        "in": "Entrada",
        "cached": "En caché",
        "out": "Salida"
      },
      "status": {
        "ok": "OK",
        "failed": "Fallida",
        "refused": "Rechazada",
        "stopped": "Detenida"
      },
      "filter": {
        "account": "Cuenta",
        "allAccounts": "Todas las cuentas",
        "from": "Desde",
        "to": "Hasta",
        "tool": "Herramienta",
        "allTools": "Todas las herramientas",
        "all": "Todos",
        "failed": "Fallidos",
        "slow": "Lentos"
      }
    }
  }
}
